import React from 'react';
import { Card, Col, Row } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { isNil } from 'lodash';

import { getFullName } from 'utils/personUtils';
import { getLocation } from 'utils/locationUtils';
import { WorkersSectionsEnum } from 'features/worker/enums';
import { WorkerItemDetailViewModel } from 'api/adminApiClient';
import { isAdminSelector } from 'redux/selectors/authenticationSelectors';
import { getWorkerTypeLabel } from 'utils/workerUtils';
import { useAppSelector } from 'hooks/useAppSelector';

type Props = {
  worker: WorkerItemDetailViewModel;
};

export default function WorkerCard(props: Props) {
  const { worker } = props;
  const isAdmin = useAppSelector(isAdminSelector);
  const {
    workerInfo,
    companyFirstName,
    companyLastName,
    memberKey,
    workerKey,
    location,
    assignmentsCount,
    workerType,
  } = worker;
  const { search } = useLocation();
  const query = queryString.parse(search);

  const fullCompanyName = getFullName(companyFirstName, companyLastName);
  const homeAddress = getLocation(
    location?.country,
    location?.address,
    location?.state || location?.internationalStateName,
    location?.city || location?.internationalCityName,
    location?.zipCode,
  );

  return (
    <Card className="card-item">
      <div className="card-inner">
        <div className="inner-text-box">
          <Link className="card-title" to={`/worker/${workerKey}`}>
            {getFullName(workerInfo?.firstName, workerInfo?.lastName)}
          </Link>
        </div>
      </div>

      <Row gutter={[20, 10]} className="titled-sheet">
        {!isNil(workerKey) && (
          <Col xs={24} md={12}>
            <div className="title">Worker ID:</div>
            <div>{workerKey}</div>
          </Col>
        )}

        {!!fullCompanyName && query.section !== WorkersSectionsEnum.Approved && (
          <Col xs={24} md={12}>
            <div className="title">Member company:</div>
            {isAdmin ? (
              <Link to={`/member/${memberKey}`}>
                <div>{fullCompanyName}</div>
              </Link>
            ) : (
              <div>{fullCompanyName}</div>
            )}
          </Col>
        )}

        {!isNil(assignmentsCount) && (
          <Col xs={24} md={12}>
            <div className="title">Number of assignments:</div>
            <div>{assignmentsCount}</div>
          </Col>
        )}

        {!isNil(workerInfo?.email) && (
          <Col xs={24} md={12}>
            <div className="title">Email:</div>
            <div>{workerInfo?.email}</div>
          </Col>
        )}

        {!isNil(workerInfo?.phoneNumber) && (
          <Col xs={24} md={12}>
            <div className="title">Phone number:</div>
            <div>{workerInfo?.phoneNumber}</div>
          </Col>
        )}

        {!!homeAddress && (
          <Col xs={24} md={12}>
            <div className="title">Home address:</div>
            <div>{homeAddress}</div>
          </Col>
        )}

        {!isNil(workerType) && (
          <Col xs={24} md={12}>
            <div className="title">Worker type:</div>
            <div>{getWorkerTypeLabel(workerType)}</div>
          </Col>
        )}

        {!isNil(workerInfo?.taxId) && (
          <Col xs={24} md={12}>
            <div className="title">Tax ID:</div>
            <div>{workerInfo?.taxId}</div>
          </Col>
        )}
      </Row>
    </Card>
  );
}
